<template>
  <el-col :span="24">
    <span>
      <span class="font-size__small">{{ fieldTitle }}:</span>
      <break-word-span
        :text="value || '-'"
        :maxLength="100"
        class="font-weight__bold"
      ></break-word-span>
    </span>
  </el-col>
</template>

<script>
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import dateFormatter from "../../../filters/dateFormatter";
import BreakWordSpan from "../ketluan/break-word-span";

export default {
  name: "hc-maybay-user-route-extend-info-item",
  mixins: [handleRequestErrorMixin],
  filters: { dateFormatter },
  components: { BreakWordSpan },
  props: ["fieldTitle", "value"],

  data() {
    return {};
  },

  watch: {},

  created() {},

  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/vemaybay/hc-maybay-user-route-extend-info-item.vue